import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { Member } from '../../../services/organizationAPI';
import { useMemberTableColumns } from './MemberTableColumns';

interface MemberTabProps {
    members: Member[];
    onEdit: (member: Member) => void;
    onAdd: () => void;
}

export const MemberTab: React.FC<MemberTabProps> = ({ members, onEdit, onAdd }) => {
    const navigate = useNavigate();

    const goToDetail = (memberId: number) => {
        navigate(`/organization/members/${memberId}`);
    };

    const columns = useMemberTableColumns({ members, onDetail: goToDetail });

    // 确保members始终是数组
    const safeMembers = Array.isArray(members) ? members : [];

    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>
                    新增成员
                </Button>
            </div>
            <Table
                columns={columns}
                dataSource={safeMembers}
                rowKey="id"
                pagination={false}
            />
        </div>
    );
};

export default MemberTab;
